import { Container } from "@shared-components/Container/Container";
import { Heading } from "@shared-components/Heading/Heading";
import { LayoutContainer } from "@shared-components/LayoutContainer/LayoutContainer";
import { Text as ReactText } from "theme-ui";
import React from "react";
import { MissionHybridSlider } from "../MissionHybridSlider";
import { generateCbKey } from "../../../shared/utils/generate-cbKey";
import {
  headingStylesCollection,
  headingStylesWhiteCollection,
  textStylesCollection,
  textStylesWhiteCollection,
} from "./styles";
import { THEMES_MAP } from "../../../carlsberg-headless/themes-map";

export type MultiSliderModuleProps = {
  themes: string[];
  heading: string;
  subHeading: string;
  variant: "brew" | "hybrid" | "mission" | "label" | "process";
  HOCSessionId: string;
  slides: {
    format: string;
    src: string;
    title?: string;
  }[];
};

const MultiSliderModule: React.FC<MultiSliderModuleProps> = ({
  heading,
  subHeading,
  variant,
  slides,
  themes,
  HOCSessionId,
}) => {
  let headingStyle;
  if (themes.includes(THEMES_MAP.layout_bg.layout_bg_white)) {
    headingStyle = headingStylesCollection;
  } else if (themes.includes(THEMES_MAP.layout_bg.layout_bg_lightergray)) {
    headingStyle = headingStylesCollection;
  } else {
    headingStyle = headingStylesWhiteCollection;
  }

  let subHeadingStyle;
  if (themes.includes(THEMES_MAP.layout_bg.layout_bg_white)) {
    subHeadingStyle = textStylesCollection;
  } else if (themes.includes(THEMES_MAP.layout_bg.layout_bg_lightergray)) {
    subHeadingStyle = textStylesCollection;
  } else {
    subHeadingStyle = textStylesWhiteCollection;
  }

  let theme;
  if (themes.includes(THEMES_MAP.layout_bg.layout_bg_white)) {
    theme = "light";
  } else if (themes.includes(THEMES_MAP.layout_bg.layout_bg_lightergray)) {
    theme = "light";
  } else {
    theme = "dark";
  }

  const hasSlides = slides.find((s) => s?.src);

  if (!hasSlides) return null;

  return (
    <LayoutContainer themes={themes}>
      <Container>
        <Heading as={"h2"} sx={headingStyle}>
          {heading}
        </Heading>
        <ReactText as={"h3"} sx={subHeadingStyle}>
          {subHeading}
        </ReactText>
      </Container>
      <Container>
        <MissionHybridSlider
          videoTitle={heading}
          theme={theme}
          variant={variant}
          slides={slides}
          cbKey={generateCbKey()}
          HOCSessionId={HOCSessionId}
        />
      </Container>
    </LayoutContainer>
  );
};

export { MultiSliderModule };
